module.exports = __webpack_public_path__ + "static/media/freshdesk.ef6fcee9.svg";